import { CoreConfigurationService } from '@ftr/owa-core';
import { OAuthService } from 'angular-oauth2-oidc';
import {
  buildTokenPayload,
  clearOAuthCallbackParams,
  configureOAuthService,
  OAUTH_POPUP_COMPLETE_MESSAGE
} from './oauth-callback.utils';
import { shouldUseSharedOAuthStorage } from './oauth-storage.factory';

type OAuthServiceWithPkce = OAuthService & {
  saveNoncesInLocalStorage: boolean;
};

export async function completeOAuthPopupCallback(
  oauthService: OAuthService,
  configurationService: CoreConfigurationService
): Promise<void> {
  configureOAuthService(oauthService, configurationService);
  await oauthService.loadDiscoveryDocument();
  await oauthService.tryLogin();

  const tokens = buildTokenPayload(oauthService);
  if (!tokens) {
    console.error('OAuth popup callback: token exchange did not produce an access token.');
    return;
  }

  if (window.opener && !window.opener.closed) {
    window.opener.postMessage({ type: OAUTH_POPUP_COMPLETE_MESSAGE, tokens }, window.location.origin);
  }
}

export function configureOAuthForIframe(
  oauthService: OAuthService,
  configurationService: CoreConfigurationService
) {
  return async () => {
    if (shouldUseSharedOAuthStorage()) {
      (oauthService as OAuthServiceWithPkce).saveNoncesInLocalStorage = true;
    }

    const isPopupCallback = !!window.opener && window.location.search.includes('code=');
    if (!isPopupCallback) {
      return;
    }

    try {
      await completeOAuthPopupCallback(oauthService, configurationService);
    } catch (error) {
      console.error('OAuth popup callback failed', error);
    } finally {
      clearOAuthCallbackParams();
      window.close();
    }
  };
}
